export function checkForMouseSupport() {
  let deviceHasMouseSupport: boolean = false;
  if (matchMedia("(pointer:fine)").matches) {
    deviceHasMouseSupport = true;
  }
  return deviceHasMouseSupport;
}
